import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import * as staticActions from "shared/ducks/staticDuck";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouterLegacy } from "core/routerUtils";
import { useTranslation } from 'react-i18next';
import { Scrollbars } from "react-custom-scrollbars-2";
import "./Subnavbar.scss";
import { isEmpty } from "lodash";
import { getPersonnelRoles } from "shared/selectors";
import HomeIcon from "assets/svgs/navHome.svg";
import PoliciesIcon from "assets/svgs/policies.svg";
import EventDashboardIcon from "assets/svgs/eventDashboard.svg";
import EventChecklistIcon from "assets/svgs/eventChecklists.svg";
import ManageRoomsIcon from "assets/svgs/manageRooms.svg";
import MonitorRoomsIcon from "assets/svgs/monitorRooms.svg";
import ExamineeRostersIcon from "assets/svgs/examineeRosters.svg";
import BookletsIcon from "assets/svgs/booklets.svg";
import IrregularitiesIcon from "assets/svgs/irregularities.svg";
import RoomDashboardIcon from "assets/svgs/roomDashboard.svg";
import RoomRosterIcon from "assets/svgs/roomRoster.svg";
import OnlineProctoringIcon from "assets/svgs/onlineProctoring.svg";
import SeatingChartIcon from "assets/svgs/seatingChart.svg";
import ExpandIcon from "assets/svgs/expandIcon.svg";
import CollapseIcon from "assets/svgs/collapseIcon.svg";
import { isWindowEvent } from "shared/helpers";
import { ONLINE_PROVIDERS } from "shared/constants";
import moment from "moment";
import { PopoverMui } from "shared/components";
import {
  is7DaysPastEvent,
  checkDate,
} from "./../../tc-event-dashboard/tc-event-roster/TcEventRoster";

const allowed = [
  "/dashboard",
  "/rooms",
  "/training",
  "/profile",
  "/irregularities",
  "/help",
  "/notifications",
];

const Subnavbar = ({
  isMobile,
  room,
  tcEvent,
  personnelRoles,
  tcEventStaff,
  event,
  currentUser,
  serverDateTimeValue,
  actions,
  isExpanded,
  setIsExpanded,
  tcCycle,
}) => {
  const { t } = useTranslation();
  const [serverDateTime, setServerDateTime] = useState(serverDateTimeValue);
  const [roomId, setRoomId] = useState("");
  const [isSupervisorRole, setIsSupervisorRole] = useState(false);
  const currentPath = window.location.pathname;
  const collapsedClass = isExpanded ? "expanded" : "collapsed";
  let className = `${collapsedClass} sticky-mobile subnavbar-container`;
  if (allowed.indexOf(currentPath) === -1 && isMobile) {
    className = "d-none";
  }
  let isDisabled = true;
  const notAllowed = [
    "/",
    "/login",
    "/register",
    "/register/success",
    "/register/email-verification",
    "/forgot-password",
    "/forgot-password/confirm",
    "/profile/personal-information",
  ];

  if (notAllowed.indexOf(currentPath) === -1) {
    isDisabled = false;
  }
  const isPsiEvent =
    !isEmpty(tcEvent) &&
    tcEvent.testingEvent?.adminId &&
    tcEvent.testingEvent.adminId.onlineProvider === ONLINE_PROVIDERS.psi;
  const testEvent = tcEvent.id;
  const location = !isEmpty(tcEvent)
    ? tcEvent?.locationEvents?.find((event) => /^open$/i.test(event.status))?.id
    : "";

  const eventDate =
    !isEmpty(tcEvent) &&
    (isWindowEvent(tcEvent.testingEvent)
      ? tcEvent.testingEvent.endTestDate
      : tcEvent.testingEvent.testDate);
  const is7DaysPastEventValue = is7DaysPastEvent(
    tcEvent.rescheduleDate || eventDate,
    serverDateTime
  );
  const disabledMessageInfo = is7DaysPastEventValue
    ? t("testCenter.eventDashboard.rosterUnavailableTooltipInfo")
    : t("testCenter.eventDashboard.rosterAvailableTooltipInfo", {
        date: moment(tcEvent?.testingEvent?.rosterStartDate).format(
          "MM.DD.YYYY"
        ),
      });

  const setServerTime = () => {
    if (!serverDateTimeValue) {
      actions.getServerDateTime().then((result) => {
        setServerDateTime(result);
      });
    }
  };

  const setSupervisorRole = () => {
    setIsSupervisorRole(false);
    if (currentUser.testCenterCyclePersonnels?.length) {
      return;
    }
    const testCenterEventData = currentUser.testCenterEventPersonnels?.filter(
      (pers) => pers.testCenterEventId === testEvent
    );
    if (testCenterEventData.length > 1) {
      const userRole = testCenterEventData.find((item) => !item.roomId)?.role
        .role;
      userRole === personnelRoles.ROOM_SUPERVISOR ||
        userRole === personnelRoles.PROCTOR ||
        userRole === personnelRoles.PROCTOR_ROVING ||
        (userRole === personnelRoles.TECH_COORDINATOR &&
          setIsSupervisorRole(true));
    } else if (testCenterEventData.length === 1) {
      const userRoleData = testCenterEventData[0]?.role?.role;
      (userRoleData === personnelRoles.ROOM_SUPERVISOR ||
        userRoleData === personnelRoles.PROCTOR ||
        userRoleData === personnelRoles.PROCTOR_ROVING ||
        userRoleData === personnelRoles.TECH_COORDINATOR) &&
        setIsSupervisorRole(true);
    }
  };

  const testCenterCoordinator =
    currentUser.testCenterCyclePersonnels && tcCycle
      ? currentUser.testCenterCyclePersonnels.find(
          (item) => item.testCenterCycleId === tcCycle.id
        )
      : {};

  const coordinator = tcEventStaff
    ? tcEventStaff.find(
        (pers) =>
          pers.personnelId === currentUser.id &&
          (pers.roleName === personnelRoles.TEST_DAY_COORDINATOR ||
            pers.roleName === personnelRoles.COORDINATOR ||
            testCenterCoordinator?.role?.role === personnelRoles.COORDINATOR)
      )
    : {};

  const isProctor = tcEventStaff
    ? tcEventStaff.find(
        (pers) =>
          pers.personnelId === currentUser.id &&
          (pers.roleName === personnelRoles.PROCTOR_ROVING ||
            pers.roleName === personnelRoles.TECH_COORDINATOR ||
            pers.roleName === personnelRoles.PROCTOR ||
            pers.roleName === personnelRoles.ROOM_SUPERVISOR)
      )
    : {};

  const proctorRole = isEmpty(coordinator) ? isProctor : {};

  useEffect(() => {
    if (!isEmpty(room)) {
      setRoomId(room.id);
      room.id && sessionStorage.setItem("roomId", room.id);
    }
  }, [room]);

  useEffect(() => {
    if (
      (currentPath.includes("irregularities") ||
        currentPath.includes("room")) &&
      sessionStorage.getItem(roomId)
    ) {
      setRoomId(sessionStorage.getItem(roomId));
    }
    if (
      (!currentPath.includes("room") ||
        currentPath.includes("rooms-dashboard") ||
        currentPath.includes("staff-and-rooms")) &&
      !currentPath.includes("irregularities")
    ) {
      sessionStorage.removeItem("roomId");
      setRoomId("");
    }
    if (
      !isEmpty(room) &&
      room.id &&
      !roomId &&
      currentPath.includes("room") &&
      !currentPath.includes("rooms")
    ) {
      sessionStorage.setItem("roomId", room.id);
      setRoomId(room.id);
    }
  }, [currentPath]);

  useEffect(() => {
    if (sessionStorage.getItem(roomId)) {
      setRoomId(sessionStorage.getItem(roomId));
    }
  }, [sessionStorage.getItem(roomId)]);

  useEffect(() => {
    if (currentUser?.testCenterEventPersonnels?.length && testEvent) {
      setSupervisorRole();
    }
  }, [currentUser?.testCenterEventPersonnels, testEvent]);

  useEffect(() => {
    if (sessionStorage.getItem(roomId)) {
      setRoomId(sessionStorage.getItem(roomId));
    }
    setServerTime();
  }, []);

  const removeRoomId = () => {
    sessionStorage.removeItem("roomId");
    setRoomId("");
  };

  const generalNav = [
    {
      link: "/dashboard",
      label: "navigation.home",
      icon: <HomeIcon />,
    },
    {
      link: "/training",
      label: "navigation.policies",
      icon: <PoliciesIcon />,
    },
  ];
  const testEventNav = [
    {
      link: `/test-event/${testEvent}`,
      label: "navigation.eventDashboard",
      icon: <EventDashboardIcon />,
      disabled: false,
      name: "eventDashboard",
    },
    {
      link: `/test-event/${testEvent}/event-checklist`,
      label: "navigation.eventChecklist",
      icon: <EventChecklistIcon />,
      disabled:
        isSupervisorRole &&
        !isEmpty(proctorRole) &&
        (proctorRole.roleName === personnelRoles.TECH_COORDINATOR ||
          proctorRole.roleName === personnelRoles.PROCTOR_ROVING),
      name: "eventChecklist",
    },
    {
      link: `/test-event/${testEvent}/staff-and-rooms`,
      label: "navigation.manageRooms",
      icon: <ManageRoomsIcon />,
      disabled:
        isSupervisorRole &&
        !isEmpty(proctorRole) &&
        (proctorRole.roleName === personnelRoles.TECH_COORDINATOR ||
          proctorRole.roleName === personnelRoles.PROCTOR_ROVING),
      name: "manageRooms",
    },
    {
      link: `/test-event/${testEvent}/rooms-dashboard`,
      label: "navigation.monitorRooms",
      icon: <MonitorRoomsIcon />,
      disabled: false,
      name: "monitorRooms",
    },
    {
      link: `/test-event/${testEvent}/rosters/${location}`,
      label: "navigation.examineesRosters",
      icon: <ExamineeRostersIcon />,
      disabled:
        is7DaysPastEventValue ||
        (tcEvent &&
          serverDateTime &&
          !checkDate(
            tcEvent.rescheduleDate || eventDate,
            tcEvent.testingEvent?.rosterStartDate,
            serverDateTime
          )) ||
        (isSupervisorRole &&
          !isEmpty(proctorRole) &&
          proctorRole.roleName === personnelRoles.TECH_COORDINATOR),
      name: "examineesRosters",
    },
  ];

  if (event?.testCenterCycle?.cycle?.logTestbookRequiredFlag) {
    testEventNav.push({
      link: `/test-event/${testEvent}/test-materials`,
      label: "navigation.testBooklets",
      icon: <BookletsIcon />,
      disabled:
        isSupervisorRole &&
        !isEmpty(proctorRole) &&
        proctorRole.roleName === personnelRoles.TECH_COORDINATOR,
      name: "testBooklets",
    });
  }

  const roomNav = [
    {
      link: `/test-event/${testEvent}/room/${roomId}`,
      label: "navigation.roomDashboard",
      icon: <RoomDashboardIcon />,
      disabled: false,
    },
    {
      link: `/test-event/${testEvent}/room/${roomId}/roster`,
      label: "navigation.roomRoster",
      icon: <RoomRosterIcon />,
      disabled: false,
    },
    {
      link: `/test-event/${testEvent}/room/${roomId}/seating-chart`,
      label: "navigation.seatingChart",
      icon: <SeatingChartIcon />,
      disabled:
        tcEvent.specialTestingFlag ||
        !event?.testCenterCycle?.cycle?.seatingChartRequiredFlag,
    },
    {
      link: `/irregularities/all/${testEvent}/${roomId}`,
      label: "navigation.irregularities",
      icon: <IrregularitiesIcon />,
      disabled: false,
    },
  ];

  const filterTestEventNav = () => {
    if (!isEmpty(personnelRoles)) {
      if (!isEmpty(proctorRole)) {
        if (
          proctorRole.roleName === personnelRoles.ROOM_SUPERVISOR ||
          proctorRole.roleName === personnelRoles.PROCTOR
        ) {
          return [];
        }
        if (proctorRole.roleName === personnelRoles.PROCTOR_ROVING) {
          return testEventNav.filter(
            (item) => !item.disabled || item.name === "examineesRosters"
          );
        }
        return testEventNav.filter((item) => !item.disabled);
      }
      return testEventNav;
    }
    return [];
  };

  const filterRoomNav = () => {
    const onlineNav = {
      link: `/test-event/${testEvent}/room/${roomId}/online-testing`,
      label: "navigation.onlineTesting",
      icon: <OnlineProctoringIcon />,
    };
    if (
      !isEmpty(room) &&
      room.roomType?.onlineFlag &&
      (tcEvent.testingEvent?.adminId.onlineProvider ===
        ONLINE_PROVIDERS.testNav ||
        isPsiEvent)
    ) {
      roomNav.splice(2, 0, onlineNav);
    }
    return roomNav.filter((item) => !item.disabled);
  };

  const filteredTestEventNav = filterTestEventNav();
  const filteredRoomNav = filterRoomNav();

  return (
    <>
      {isMobile ? (
        <div className={className}>
          <Scrollbars className="scrollbar">
            <nav className="Subnavbar">
              <NavLink to="/dashboard">
                {t("navigation.dashboard")}
              </NavLink>
              <NavLink to="/training">
                {t("navigation.policies")}
              </NavLink>
              <NavLink to="/profile">
                {t("navigation.profile")}
              </NavLink>
              <NavLink to="/notifications">
                {t("navigation.notifications")}
              </NavLink>
            </nav>
          </Scrollbars>
        </div>
      ) : (
        !isDisabled && (
          <div className={className}>
            <div className="subnavbar-fixed">
              <Scrollbars className="scrollbar">
                <nav className="Subnavbar">
                  {generalNav.map((item, index) => (
                    <PopoverMui
                      title={t(item.label)}
                      arrow
                      visible={!isExpanded}
                      key={index}
                      handleClick={removeRoomId}
                    >
                      <NavLink
                        className="sidebar-link tooltip-menu-item"
                        end
                        to={item.link}
                      >
                        <div>{item.icon}</div>
                        {isExpanded && <span>{t(item.label)}</span>}
                      </NavLink>
                    </PopoverMui>
                  ))}
                </nav>

                {(currentPath.includes("test-event") ||
                  currentPath.includes("irregularities")) &&
                  !isEmpty(event.currentEvent) &&
                  filteredTestEventNav.length > 0 && (
                    <nav className="Subnavbar">
                      {filteredTestEventNav.map((item, index) =>
                        item.disabled ? (
                          <PopoverMui
                            key={index}
                            triggerOnClick
                            title={disabledMessageInfo}
                            visible={true}
                          >
                            <div className="sidebar-link tooltip-menu-item disabled">
                              <div>{item.icon}</div>
                              {isExpanded && (
                                <span>{t(item.label)}</span>
                              )}
                            </div>
                          </PopoverMui>
                        ) : (
                          <PopoverMui
                            title={t(item.label)}
                            arrow
                            visible={!isExpanded}
                            key={index}
                            handleClick={removeRoomId}
                          >
                            <NavLink
                              className="sidebar-link tooltip-menu-item"
                              end
                              to={item.link}
                            >
                              <div>{item.icon}</div>
                              {isExpanded && (
                                <span>{t(item.label)}</span>
                              )}
                            </NavLink>
                          </PopoverMui>
                        )
                      )}

                      {!roomId && !isSupervisorRole && (
                        <PopoverMui
                          title={t("navigation.irregularities")}
                          arrow
                          visible={!isExpanded}
                        >
                          <NavLink
                            className="sidebar-link tooltip-menu-item"
                            end
                            to={`/irregularities/all/${testEvent}`}
                          >
                            <div>
                              <IrregularitiesIcon />
                            </div>
                            {isExpanded && (
                              <span>
                                {t("navigation.irregularities")}
                              </span>
                            )}
                          </NavLink>
                        </PopoverMui>
                      )}
                    </nav>
                  )}

                {sessionStorage.getItem("roomId") &&
                  !isEmpty(room) &&
                  room.id &&
                  (currentPath.includes("room") ||
                    currentPath.includes("irregularities")) && (
                    <nav className="Subnavbar">
                      {filteredRoomNav.map((item, index) => (
                        <PopoverMui
                          title={t(item.label)}
                          arrow
                          visible={!isExpanded}
                          key={index}
                        >
                          <NavLink
                            className="sidebar-link tooltip-menu-item"
                            end
                            to={item.link}
                          >
                            <div>{item.icon}</div>
                            {isExpanded && (
                              <span>{t(item.label)}</span>
                            )}
                          </NavLink>
                        </PopoverMui>
                      ))}
                    </nav>
                  )}

                <div className="expand-collapse-container">
                  <PopoverMui
                    title={t("navigation.expand")}
                    arrow
                    visible={!isExpanded}
                  >
                    <div
                      className="sidebar-link"
                      onClick={() => setIsExpanded(!isExpanded)}
                    >
                      <div>
                        {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
                      </div>
                      {isExpanded && (
                        <span>{t("common.labels.collapse")}</span>
                      )}
                    </div>
                  </PopoverMui>
                </div>
              </Scrollbars>
            </div>
          </div>
        )
      )}
    </>
  );
};
function mapStateToProps(state) {
  return {
    currentUser: state.users.currentUser,
    tcEvent: state.tcEvent.currentEvent,
    room: state.roomOptions.room,
    personnelRoles: getPersonnelRoles(state),
    tcEventStaff: state.staff.tcEventStaff,
    event: state.tcEvent,
    serverDateTimeValue: state.statics.serverDateTime,
    tcCycle: state.tcEvent.testCenterCycle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...staticActions,
      },
      dispatch
    ),
  };
}

export default withRouterLegacy(
  connect(mapStateToProps, mapDispatchToProps)(Subnavbar)
);
